module.exports = __webpack_public_path__ + "img/52_28.073c1856.png";